import styled from '@emotion/styled'

import { Color } from '../../enums/color'
import { DefaultValue } from '../../enums/defaultValue'
import { Spacing } from '../../enums/spacing'
import { getShadow } from '../../utils/getShadow'

interface ProgressNotificationWrapperProps {
  clickable?: boolean
}

export const ProgressNotificationWrapper = styled.div<ProgressNotificationWrapperProps>`
  width: 450px;
  padding: ${Spacing.S16} ${Spacing.S24} ${Spacing.S24};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'initial')};
  ${getShadow('elevatedStrong')};
`

export const Header = styled.header`
  display: flex;
`

export const CloseButtonWrapper = styled.figure`
  margin: -${Spacing.S6} -${Spacing.S12} -${Spacing.S6} auto;
`

export const Content = styled.div``
